module.exports = __webpack_public_path__ + "img/animation_logo_final.f1b10b28.jpg";